import { Card, CardContent, Grid } from '@mui/material'
import React, { type ReactNode } from 'react'
import { Children } from 'react'

interface ScrollableListProps {
  slotCount: number
  children: ReactNode | ReactNode[]
}

const ScrollableList: React.FC<ScrollableListProps> = ({ slotCount = 0, children }: ScrollableListProps) => {
  const childrenArray = Children.toArray(children)

  return (
    <Card
      variant='outlined'
      sx={{
        width: '400px',
        height: 1,
        margin: 'auto',
        background: 'transparent',
      }}
    >
      <CardContent
        sx={{
          height: 1,
          padding: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {
          Children.map(childrenArray, (child, index) => {
            if (index < slotCount) {
              return child
            }
          })
        }
        <Grid
          display='flex' flexDirection='column' gap={1}
          sx={{ width: 1, overflowY: 'auto' }}
          style={{ height: `calc(100% - ${slotCount * (40 + 8)}px` }} // subtract height of filter text fields and margin
        >
          {
            Children.map(childrenArray, (child, index) => {
              if (index >= slotCount) {
                return (
                  <Grid>
                    {child}
                  </Grid>
                )
              }
            })
          }
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ScrollableList
